const BASE = import.meta.env.VITE_API_URL || 'http://localhost:8787'

async function adminRequest<T>(
  path: string,
  lineUid: string,
  options?: RequestInit,
): Promise<T> {
  const res = await fetch(`${BASE}/api/admin${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-admin-line-uid': lineUid,
    },
    ...options,
  })
  const data = await res.json() as { success: boolean; data?: T; error?: string }
  if (!data.success) throw new Error(data.error ?? 'Admin API error')
  return data.data as T
}

export const adminApi = {
  me: (lineUid: string) =>
    adminRequest('/me', lineUid),

  dashboard: (lineUid: string) =>
    adminRequest('/dashboard', lineUid),

  users: (lineUid: string, params: { search?: string; limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams()
    if (params.search) qs.set('search', params.search)
    if (params.limit) qs.set('limit', String(params.limit))
    if (params.offset) qs.set('offset', String(params.offset))
    return adminRequest(`/users?${qs}`, lineUid)
  },

  userDetail: (lineUid: string, userId: string) =>
    adminRequest(`/users/${userId}`, lineUid),

  unlock: (lineUid: string, userId: string, count: number, reason?: string) =>
    adminRequest(`/users/${userId}/unlock`, lineUid, {
      method: 'POST',
      body: JSON.stringify({ count, reason }),
    }),

  changeRole: (lineUid: string, userId: string, role: 'user' | 'admin' | 'super_admin') =>
    adminRequest(`/users/${userId}/role`, lineUid, {
      method: 'POST',
      body: JSON.stringify({ role }),
    }),

  transactions: (lineUid: string, params: { status?: string; limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams()
    if (params.status) qs.set('status', params.status)
    if (params.limit) qs.set('limit', String(params.limit))
    if (params.offset) qs.set('offset', String(params.offset))
    return adminRequest(`/transactions?${qs}`, lineUid)
  },

  txAction: (lineUid: string, txId: string, action: 'approve' | 'reject', reason?: string) =>
    adminRequest(`/transactions/${txId}/action`, lineUid, {
      method: 'POST',
      body: JSON.stringify({ action, reason }),
    }),

  logs: (lineUid: string, limit = 100) =>
    adminRequest(`/logs?limit=${limit}`, lineUid),

  apiCosts: (lineUid: string, month?: string) => {
    const path = month ? '/api-costs?month=' + month : '/api-costs'
    return adminRequest(path, lineUid)
  },
}
